(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  /*
  ============================================================
  FYNESHYT PRODUCT IMAGE CAROUSEL
  ============================================================

  Desktop:
    Arrow buttons control the image track.

  Mobile:
    Native horizontal touch scrolling handles the carousel.

  JavaScript only:
    - controls desktop arrows
    - updates the active mobile dot
  ============================================================
*/

  (() => {
    const carousels = document.querySelectorAll('[data-product-carousel]');

    if (!carousels.length) return;

    carousels.forEach((carousel) => {
      const track = carousel.querySelector('[data-image-track]');
      const slides = carousel.querySelectorAll('[data-image-slide]');
      const dots = carousel.querySelectorAll('[data-carousel-dot]');
      const previousButton = carousel.querySelector('[data-carousel-prev]');
      const nextButton = carousel.querySelector('[data-carousel-next]');

      if (!track || slides.length <= 1) return;

      let currentIndex = 0;

      const updateArrows = (index) => {
        if (previousButton) {
          previousButton.style.display = index === 0 ? 'none' : '';
        }

        if (nextButton) {
          nextButton.style.display = index === slides.length - 1 ? 'none' : '';
        }
      };

      const updateDots = (index) => {
        dots.forEach((dot, dotIndex) => {
          dot.classList.toggle('is-active', dotIndex === index);
        });
      };

      const goToSlide = (index) => {
        currentIndex = Math.max(0, Math.min(index, slides.length - 1));
        const slide = slides[currentIndex];
        if (!slide) return;

        track.scrollTo({
          left: slide.offsetLeft,
          behavior: 'smooth',
        });

        updateDots(currentIndex);
        updateArrows(currentIndex);
      };

      if (previousButton) {
        previousButton.addEventListener('click', (event) => {
          event.preventDefault();

          goToSlide(currentIndex - 1);
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', (event) => {
          event.preventDefault();

          goToSlide(currentIndex + 1);
        });
      }

      /*
      Update the dots while the customer swipes on mobile.
    */

      let scrollTimeout;

      track.addEventListener(
        'scroll',
        () => {
          window.clearTimeout(scrollTimeout);

          scrollTimeout = window.setTimeout(() => {
            const slideWidth = track.clientWidth;

            if (!slideWidth) return;

            const index = Math.round(track.scrollLeft / slideWidth);

            currentIndex = Math.max(0, Math.min(index, slides.length - 1));

            updateDots(currentIndex);
          }, 80);
        },
        { passive: true }
      );

      updateDots(0);
      updateArrows(0);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  /* ============================================================
     ON ROTATION — LIVE CLOCK

     Always shows the current time in India Standard Time,
     dry and lowercase. Ticks on its own, no page reload,
     no API calls — just Date + Intl formatting.
     ============================================================ */

  (() => {
    const weekdayFormatter = new Intl.DateTimeFormat('en-US', {
      weekday: 'short',
      timeZone: 'Asia/Kolkata',
    });

    const dateFormatter = new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric',
      timeZone: 'Asia/Kolkata',
    });

    const timeFormatter = new Intl.DateTimeFormat('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      timeZone: 'Asia/Kolkata',
    });

    /* Re-query on every tick — the theme editor swaps this
       element's DOM node whenever a footer setting changes,
       so a cached reference would otherwise go stale. */
    const updateClock = () => {
      const clock = document.querySelector('[data-on-rotation-clock]');

      if (!clock) return;

      const now = new Date();

      const weekday = weekdayFormatter.format(now).toLowerCase();
      const date = dateFormatter.format(now).toLowerCase();
      const time = timeFormatter.format(now).toLowerCase();

      clock.textContent = `${weekday} · ${date} · ${time} GMT+5:30`;
    };

    updateClock();

    window.setInterval(updateClock, 30000);

    document.addEventListener('shopify:section:load', updateClock);
  })();

  /* ============================================================
     FOOTER ACCORDIONS

     The Information column defaults to <details open> in the
     markup (safe if JS is slow/absent). This just closes it
     on mobile widths and keeps it forced open from 768px up,
     where it's meant to read as a plain column, not a toggle.
     ============================================================ */

  (() => {
    const mediaQuery = window.matchMedia('(min-width: 768px)');

    const syncAccordions = (isWideEnoughToStayOpen) => {
      document.querySelectorAll('.fyneshyt-footer__accordion').forEach((details) => {
        details.open = isWideEnoughToStayOpen;
      });
    };

    syncAccordions(mediaQuery.matches);

    mediaQuery.addEventListener('change', (event) => {
      syncAccordions(event.matches);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-grid"] && !Shopify.designMode) return;
  try {
    
  /* ============================================================
   FYNESHYT — NEW DROPS IMAGE CAROUSEL

   Desktop:
     Arrow buttons control the image track.

   Mobile:
     Native horizontal touch scrolling handles the carousel.

   JavaScript:
     - controls desktop arrows
     - updates mobile dots
     - tracks mobile swipe position
   ============================================================ */

  (() => {
    const carousels = document.querySelectorAll('[data-product-carousel]');

    if (!carousels.length) return;

    carousels.forEach((carousel) => {
      const track = carousel.querySelector('[data-image-track]');

      const slides = carousel.querySelectorAll('[data-image-slide]');

      const dots = carousel.querySelectorAll('[data-carousel-dot]');

      const previousButton = carousel.querySelector('[data-carousel-prev]');

      const nextButton = carousel.querySelector('[data-carousel-next]');

      if (!track || slides.length <= 1) return;

      let currentIndex = 0;

      /* ==========================================================
       UPDATE ARROWS
       ========================================================== */

      const updateArrows = (index) => {
        if (previousButton) {
          previousButton.style.display = index === 0 ? 'none' : '';
        }

        if (nextButton) {
          nextButton.style.display = index === slides.length - 1 ? 'none' : '';
        }
      };

      /* ==========================================================
       UPDATE DOTS
       ========================================================== */

      const updateDots = (index) => {
        dots.forEach((dot, dotIndex) => {
          dot.classList.toggle('is-active', dotIndex === index);
        });
      };

      /* ==========================================================
       GO TO SLIDE
       ========================================================== */

      const goToSlide = (index) => {
        currentIndex = Math.max(0, Math.min(index, slides.length - 1));

        const slide = slides[currentIndex];

        if (!slide) return;

        track.scrollTo({
          left: slide.offsetLeft,
          behavior: 'smooth',
        });

        updateDots(currentIndex);

        updateArrows(currentIndex);
      };

      /* ==========================================================
       PREVIOUS BUTTON
       ========================================================== */

      if (previousButton) {
        previousButton.addEventListener('click', (event) => {
          event.preventDefault();

          goToSlide(currentIndex - 1);
        });
      }

      /* ==========================================================
       NEXT BUTTON
       ========================================================== */

      if (nextButton) {
        nextButton.addEventListener('click', (event) => {
          event.preventDefault();

          goToSlide(currentIndex + 1);
        });
      }

      /* ==========================================================
       MOBILE SWIPE / SCROLL

       The browser performs the actual swipe.

       We only calculate which image is currently visible
       and update the dots.
       ========================================================== */

      let scrollTimeout;

      track.addEventListener(
        'scroll',
        () => {
          window.clearTimeout(scrollTimeout);

          scrollTimeout = window.setTimeout(() => {
            const slideWidth = track.clientWidth;

            if (!slideWidth) return;

            const index = Math.round(track.scrollLeft / slideWidth);

            currentIndex = Math.max(0, Math.min(index, slides.length - 1));

            updateDots(currentIndex);
          }, 80);
        },
        { passive: true }
      );

      /* ==========================================================
       INITIAL STATE
       ========================================================== */

      updateDots(0);

      updateArrows(0);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
